import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { RECOMMENDATIONS_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

interface AutomatedRecommendationSettings {
  traffic_split?: number;
  duration?: number;
  confidence_level?: number;
  minimum_sample_size?: number;
  conversion_goal?: string;
}

export default async function update_automated_recommendation_settings_api_call(
  recommendationId: string,
  settings: AutomatedRecommendationSettings
) {
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  if (!accessToken) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${RECOMMENDATIONS_API}/${recommendationId}/settings`,
    method: 'PATCH',
    body: applicationWWWXRLEncodedBodyBuilder(settings),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'UPDATE_AUTOMATED_RECOMMENDATION_SETTINGS';
  const customMsg = 'Settings updated successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    return response?.data || true;
  }
}
